import { useSelector, useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ProductLimitModal.module.css";
import { Link } from "react-router-dom";

export default function ProductLimitModal() {
    const dispatch = useDispatch();

    const handleClose = function () {
        dispatch(uiActions.setProductLimitModalActive(false));
    }

    const handleDODClick = function name(params) {
        window.open("https://commercial.tarkett.com/inspiration-center/designer-on-demand", '_blank', 'noopener,noreferrer');
        handleClose();
    }

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.modalContent}>
                    <h2>Warning</h2>
                    <p>You've reached the maximum of 5 products per design. For more design support, please contact our Designer on Demand service.</p>

                    <button onClick={handleDODClick}>Designer on Demand</button>
                    
                </div>
            </PopUpModal>
        </>
    );
}
